import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach bearer token from localStorage (fallback alongside httpOnly cookie)
api.interceptors.request.use((config) => {
  try {
    const t = localStorage.getItem("iv_token");
    if (t) config.headers.Authorization = `Bearer ${t}`;
  } catch (error) {
    console.warn("Failed to retrieve auth token:", error);
  }
  return config;
});

export const CATEGORIES = [
  { id: "adventure", name: "Adventure", emoji: "Mountain", hint: "Trek, raft, surf" },
  { id: "explore", name: "Explore", hint: "Offbeat journeys" },
  { id: "medical", name: "Medical", hint: "Wellness & care" },
  { id: "relaxation", name: "Relaxation", hint: "Backwaters, spas" },
  { id: "fun", name: "Fun", hint: "Food, festivals" },
  { id: "historic", name: "Historic", hint: "Forts, palaces" },
  { id: "cultural", name: "Cultural", hint: "Crafts, arts" },
  { id: "spiritual", name: "Spiritual", hint: "Yoga, ashrams" },
];

export const CATEGORY_META = {
  adventure: { badge: "bg-emerald-50 text-emerald-800", ring: "ring-emerald-200" },
  explore: { badge: "bg-sky-50 text-sky-800", ring: "ring-sky-200" },
  medical: { badge: "bg-teal-50 text-teal-800", ring: "ring-teal-200" },
  relaxation: { badge: "bg-emerald-50 text-emerald-900", ring: "ring-emerald-200" },
  fun: { badge: "bg-amber-50 text-amber-900", ring: "ring-amber-200" },
  historic: { badge: "bg-slate-100 text-slate-900", ring: "ring-slate-200" },
  cultural: { badge: "bg-rose-50 text-rose-900", ring: "ring-rose-200" },
  spiritual: { badge: "bg-amber-50 text-amber-900", ring: "ring-amber-200" },
};

export const fmt = (n, c = "USD") => {
  try { return new Intl.NumberFormat("en-US", { style: "currency", currency: c, maximumFractionDigits: 0 }).format(n); } catch (e) { return `$${n}`; }
};
export const fmt2 = (n, c = "USD") => {
  try { return new Intl.NumberFormat("en-US", { style: "currency", currency: c, maximumFractionDigits: 2 }).format(n); } catch (e) { return `$${n}`; }
};
